import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["classroomToggle", "classroomFields"]

  connect() {
    this.toggleClassroomFields()
  }

  toggleClassroomFields() {
    if (!this.hasClassroomFieldsTarget) return

    const shouldShow = this.hasClassroomToggleTarget && this.classroomToggleTarget.checked
    this.classroomFieldsTarget.style.display = shouldShow ? "" : "none"
    this.classroomFieldsTarget.querySelectorAll("input").forEach((input) => {
      input.disabled = !shouldShow
    })
  }
}
